import { Components } from '@mui/material';

export const button: Components = {
  MuiToggleButton: {
    styleOverrides: {
      root: {
        borderColor: '#16b5a5 !important',
        padding: '4px 16px',
        '&.Mui-selected': {
          color: '#fff',
          backgroundColor: '#16b5a5 !important',
        },
        '&.Mui-selected :hover': {
          color: '#fff',
          backgroundColor: '#16b5a5 !important',
          opacity: 0.7,
        },
      },
    },
  },
};
